import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIconDisabled.svg'
import _imports_1 from '@/assets/filterIcon.svg'
import _imports_2 from '@/assets/cancel.svg'
import _imports_3 from '@/assets/addImage.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 overflow-y-hidden" }
const _hoisted_2 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Systems", -1)
const _hoisted_4 = { class: "cardbody" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_6 = { class: "flex flex-row-reverse items-center" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "my-3 text-xs" }, " Risk management is the process of identifying, assessing and controlling financial, legal, strategic and security risks to an organization’s capital and earnings. These threats, or risks, could stem from a wide variety of sources, including financial uncertainty, legal liabilities, strategic management errors, accidents and natural disasters.To reduce risk, an organization needs to apply resources to minimize, monitor and control the impact of negative events while maximizing positive events. A consistent, systemic and integrated approach to risk management can help determine how best to identify, manage and mitigate significant risks. ", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", null, "System", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5 cursor-pointer"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_17 = { class: "formcontainer flex flex-col" }
const _hoisted_18 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_19 = { class: "w-6/12" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Name", -1)
const _hoisted_21 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_22 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_23 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_24 = {
  key: 2,
  class: "invalid-feedback text-xs"
}
const _hoisted_25 = { class: "w-6/12 leftspacing" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Category", -1)
const _hoisted_27 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_28 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_29 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "text-error text-xs" }, "Charcter Limit is exceeded", -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "w-full upperspacing" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Description", -1)
const _hoisted_35 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_36 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_37 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_38 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_39 = { class: "col-md-6 w-6/12" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Model", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Please select one", -1)
const _hoisted_42 = ["value"]
const _hoisted_43 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_44 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_45 = { class: "col-md-6 w-6/12 leftspacing" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Add (URL / IP Address / Domain Name)", -1)
const _hoisted_47 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_48 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_49 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_50 = {
  key: 2,
  class: "error-text text-xs"
}
const _hoisted_51 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "This url already exists", -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "row flex w-full upperspacing" }
const _hoisted_55 = { class: "col-md-6 w-full" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Vendor", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "No Vendors Found", -1)
const _hoisted_58 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_59 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_60 = { class: "row w-full upperspacing" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Logo", -1)
const _hoisted_62 = { class: "flex justify-center" }
const _hoisted_63 = { class: "flex justify-center" }
const _hoisted_64 = ["htmlFor"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "w-20 h-20 cursor-pointer"
}, null, -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = ["htmlFor"]
const _hoisted_68 = ["id"]
const _hoisted_69 = { class: "flex justify-center items-center mt-2" }
const _hoisted_70 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_71 = { class: "text-xs font-bold" }
const _hoisted_72 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_73 = {
  key: 1,
  class: "border w-full rounded py-2 border-lightgrey"
}
const _hoisted_74 = { class: "flex justify-center p-2 items-center" }
const _hoisted_75 = ["htmlFor"]
const _hoisted_76 = ["src"]
const _hoisted_77 = ["htmlFor"]
const _hoisted_78 = ["id"]
const _hoisted_79 = { class: "flex justify-center items-center mt-2" }
const _hoisted_80 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_81 = { class: "text-xs font-bold" }
const _hoisted_82 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_83 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_84 = { class: "flex justify-center items-center mt-4 mx-0" }
const _hoisted_85 = ["disabled"]
const _hoisted_86 = ["disabled"]
const _hoisted_87 = ["disabled"]
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_popup = _resolveComponent("popup")!
  const _component_spinner = _resolveComponent("spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(["flex items-center", _ctx.systemsArray.length == 0?'btndisabled pointer-events-none':'filterButton h-8']),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
              }, [
                (_ctx.systemsArray.length == 0)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : (_openBlock(), _createElementBlock("img", _hoisted_8)),
                _createTextVNode(" Filters ")
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "btnprimary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddPopup()))
              }, "Add")
            ])
          ])
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", null, [
        _createVNode(_component_newTable, {
          tableRowData: _ctx.systemsArray,
          headersData: _ctx.headers,
          tableProps: _ctx.tableProps,
          openPopup: false,
          navigate: true,
          loadData: _ctx.dataLoading
        }, null, 8, ["tableRowData", "headersData", "tableProps", "loadData"]),
        (_ctx.toolTipActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showSystemPopup==true)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 0,
            popUp: _ctx.showSystemPopup
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCancelbtn('close')))
                }, _hoisted_15)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': (_ctx.v$.mainSystem.systemName.$error || _ctx.checkSystemName)
                                        }]),
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mainSystem.systemName) = $event)),
                              placeholder: "System Name",
                              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.mainSystem.systemName.$touch()))
                            }, null, 34), [
                              [
                                _vModelText,
                                _ctx.mainSystem.systemName,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.mainSystem.systemName.$error || _ctx.checkSystemName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  (_ctx.v$.mainSystem.systemName.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Required"))
                                    : (_ctx.v$.mainSystem.systemName.required && _ctx.v$.mainSystem.systemName.restrictNames50.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Charcter Limit is exceeded"))
                                      : (_ctx.checkSystemName)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "System Name already exists."))
                                        : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _createVNode(_component_multiselect, {
                              modelValue: _ctx.mainSystem.systemCategory,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mainSystem.systemCategory) = $event)),
                              modelModifiers: { trim: true },
                              options: _ctx.systemCategoryDisplay,
                              onSearchChange: _ctx.asyncSystemCategoryDataFind,
                              onSelect: _ctx.checkCategoryLength,
                              multiple: false,
                              searchable: true,
                              "hide-selected": true,
                              "open-direction": "bottom",
                              "close-on-select": true,
                              "clear-on-select": true,
                              hideArrow: false,
                              placeholder: "System Category",
                              deselectLabel: "",
                              showNoOptions: false,
                              selectLabel: "",
                              class: _normalizeClass(["custom-multiselect userSelect", {
                                            'is-invalidmultiselect': _ctx.v$.mainSystem.systemCategory.$error || _ctx.displayCategoryLengthErrorMessage,
                                            'has-options': _ctx.systemCategoryDisplay && _ctx.systemCategoryDisplay.length > 0,
                                            'no-options': !_ctx.systemCategoryDisplay.length &&  _ctx.searchValue !== '',
                                        }])
                            }, null, 8, ["modelValue", "options", "onSearchChange", "onSelect", "class"]),
                            (_ctx.v$.mainSystem.systemCategory.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  (_ctx.v$.mainSystem.systemCategory.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Required"))
                                    : (_ctx.v$.mainSystem.systemCategory.required && _ctx.v$.mainSystem.systemCategory.restrictNames50.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_ctx.displayCategoryLengthErrorMessage)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                                : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _withDirectives(_createElementVNode("textarea", {
                            type: "text",
                            class: _normalizeClass(["inputboxstyling", {
                                        'is-invalid': (_ctx.v$.mainSystem.systemDescription.$error)
                                    }]),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.mainSystem.systemDescription) = $event)),
                            placeholder: "Description",
                            rows: "3",
                            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.mainSystem.systemDescription.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.mainSystem.systemDescription,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.mainSystem.systemDescription.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                (_ctx.v$.mainSystem.systemDescription.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Required"))
                                  : (_ctx.v$.mainSystem.systemDescription.required && _ctx.v$.mainSystem.systemDescription.restrictCharacters.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mainSystem.model) = $event)),
                              class: _normalizeClass({
                                            'is-invalid': _ctx.v$.mainSystem.model.$error,
                                            'inputboxstylingForSelectAtPopup': _ctx.mainSystem.model == '',
                                            'stylingForInputboxstylingForSelectAtPopup': _ctx.mainSystem.model != ''
                                        })
                            }, [
                              _hoisted_41,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemModels, (name) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  class: "optionColors",
                                  key: name,
                                  value: name
                                }, _toDisplayString(name), 9, _hoisted_42))
                              }), 128))
                            ], 2), [
                              [_vModelSelect, _ctx.mainSystem.model]
                            ]),
                            (_ctx.v$.mainSystem.model.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  (_ctx.v$.mainSystem.model.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _hoisted_46,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': (_ctx.v$.mainSystem.url.$error||_ctx.checkwebsiteDomain)
                                        }]),
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mainSystem.url) = $event)),
                              placeholder: "Url",
                              onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.mainSystem.url.$touch()))
                            }, null, 34), [
                              [
                                _vModelText,
                                _ctx.mainSystem.url,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.mainSystem.url.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  (_ctx.v$.mainSystem.url.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, "Required"))
                                    : (_ctx.v$.mainSystem.url.required && _ctx.v$.mainSystem.url.restrictCharacters100.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Charcter Limit is exceeded"))
                                      : (_ctx.v$.mainSystem.url.required &&  _ctx.v$.mainSystem.url.websiteValidateWithIp.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Invalid Website"))
                                        : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkwebsiteDomain)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_53))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _hoisted_56,
                            _createVNode(_component_multiselect, {
                              modelValue: _ctx.mainSystem.vendor,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mainSystem.vendor) = $event)),
                              options: _ctx.vendorDisplayList,
                              searchable: true,
                              onSearchChange: _ctx.asyncFindVendor,
                              "close-on-select": true,
                              "show-labels": false,
                              "hide-selected": true,
                              placeholder: "Vendor",
                              "open-direction": "bottom",
                              multiple: false,
                              showNoOptions: false,
                              "clear-on-select": true,
                              label: "label",
                              "track-by": "value",
                              hideArrow: false,
                              class: _normalizeClass(["custom-multiselect userSelect", {
                                            'is-invalidmultiselect': _ctx.v$.mainSystem.vendor.$error,
                                            'has-options': _ctx.vendorDisplayList && _ctx.vendorDisplayList.length > 0,
                                            'no-options': !_ctx.vendorDisplayList.length &&  _ctx.searchValue !== '',
                                        }])
                            }, {
                              noResult: _withCtx(() => [
                                _hoisted_57
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "onSearchChange", "class"]),
                            (_ctx.v$.mainSystem.vendor.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                  (_ctx.v$.mainSystem.vendor.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          (_ctx.mainSystem.imageUrl == '' && !_ctx.mainSystem._id)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([{'is-invalid borderRed': _ctx.v$.fileName.$error,}, "border w-full rounded py-2 border-lightgrey inputboxstyling"])
                              }, [
                                _createElementVNode("div", _hoisted_62, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("label", {
                                        htmlFor: _ctx.mainSystem,
                                        class: "mt-2"
                                      }, _hoisted_66, 8, _hoisted_64),
                                      _createElementVNode("label", { htmlFor: _ctx.mainSystem }, [
                                        _createElementVNode("input", {
                                          type: "file",
                                          id: _ctx.mainSystem,
                                          style: {"display":"none"},
                                          ref: "fileInput",
                                          onChange: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.imageCheckFile('fileInput','add')), ["stop"]))
                                        }, null, 40, _hoisted_68)
                                      ], 8, _hoisted_67)
                                    ]),
                                    _createElementVNode("div", _hoisted_69, [
                                      (_ctx.fileName!='')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                            _createTextVNode("Selected File : "),
                                            _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.fileName), 1)
                                          ]))
                                        : (_ctx.fileName == '')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString('Click on the icon for uploading a file')))
                                          : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ], 2))
                            : (_ctx.mainSystem._id && _ctx.mainSystem.imageUrl !='')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                  _createElementVNode("div", _hoisted_74, [
                                    _createElementVNode("label", {
                                      htmlFor: _ctx.mainSystem,
                                      class: "mt-2"
                                    }, [
                                      _createElementVNode("img", {
                                        src: _ctx.mainSystem.imageUrl,
                                        alt: "",
                                        class: "w-20 h-20 cursor-pointer"
                                      }, null, 8, _hoisted_76)
                                    ], 8, _hoisted_75),
                                    _createElementVNode("label", { htmlFor: _ctx.mainSystem }, [
                                      _createElementVNode("input", {
                                        type: "file",
                                        id: _ctx.mainSystem,
                                        style: {"display":"none"},
                                        ref: "fileInput",
                                        onChange: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.imageCheckFile('fileInput','edit')), ["stop"]))
                                      }, null, 40, _hoisted_78)
                                    ], 8, _hoisted_77)
                                  ]),
                                  _createElementVNode("div", _hoisted_79, [
                                    (_ctx.fileName!='')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                          _createTextVNode("Selected File : "),
                                          _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.fileName), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                          (_ctx.v$.fileName.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                (_ctx.v$.fileName.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("button", {
                            disabled: _ctx.clickOnButton,
                            class: _normalizeClass([JSON.stringify(_ctx.mainSystem) == JSON.stringify(this.dummySystem) ? 'btndisabled pointer-events-none' :'btnprimary', "btnprimary mr-1.5"]),
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onCancelbtn('cancel')))
                          }, "Cancel", 10, _hoisted_85),
                          (!_ctx.mainSystem._id)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                disabled: _ctx.clickOnButton,
                                class: _normalizeClass([JSON.stringify(_ctx.mainSystem) == JSON.stringify(this.dummySystem) ? 'btndisabled pointer-events-none' :'btnprimary', "btnprimary mr-1.5"]),
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addSystem('add')))
                              }, "Save", 10, _hoisted_86))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                disabled: _ctx.clickOnButton,
                                class: _normalizeClass([JSON.stringify(_ctx.mainSystem) == JSON.stringify(this.dummySystem) ? 'btndisabled pointer-events-none' :'btnprimary', "btnprimary mr-1.5"]),
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.editSystem('update')))
                              }, "Update", 10, _hoisted_87))
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_88
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.spinnerLoading)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}